import React from 'react';
import { successStories } from "../components/assets/data/dummydata"



export const SuccessStories = () => {
  return (
    <section className="py-1">
      <div className="container mx-auto">
        <h2 className="text-3xl font-semibold text-black text-center mb-6">Success Stories</h2>
        <div className="flex overflow-x-auto space-x-6 p-6">
          {successStories.map((story) => (
            <div key={story.id} className="min-w-[300px] bg-white rounded-lg shadow-md p-4">
              <img
                src={story.userImage}
                alt={story.title}
                className="w-16 h-16 rounded-full mb-4 mx-auto"
              />
              <div className="text-center">
                <p className="text-sm text-gray-500 mb-2">{story.date}</p>
                {/* <h3 className="text-lg font-semibold mb-2">{story.title}</h3> */}
                <p className="text-gray-700">{story.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
